import { lazy } from 'react';

import jsonBigint from 'src/libs/JSONParser/json-bigint';

const jsonBigAlways = jsonBigint({ useNativeBigInt: true });

async function readSingleFile(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      resolve(e?.target?.result);
    };
    reader.readAsArrayBuffer(file);
    reader.onabort = reject;
    reader.onerror = reject;
  });
}

export const blobToJSON = async (data: Blob) => {
  if (data.size === 2) {
    return [];
  }
  const buffer = (await readSingleFile(data)) as ArrayBuffer;
  // const parsed = await parseZstdStreaming(buffer);

  return jsonBigAlways.parse(buffer);
};

export const base64ToArrayBuffer = (base64: string) => {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

export function parseZstdStreaming(bin: ArrayBuffer | Uint8Array): Promise<string> {
  return new Promise(async (resolve, reject) => {
    const { ZstdCodec } = await import('zstd-codec');

    ZstdCodec.run((zstd) => {
      try {
        const input = bin instanceof Uint8Array ? bin : new Uint8Array(bin);

        const output = new zstd.Streaming().decompress(input);

        const text = output && output.length ? new TextDecoder().decode(output) : '';
        resolve(text);
      } catch (err) {
        reject(err);
      }
    });
  });
}
